import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  UpdateOfferBypassRegionFilterSettingPayload,
  updateOfferBypassRegionFilterSetting,
} from '~/services/PromoService';

import { offerBypassRegionFilterQueryKeys } from './offerBypassRegionFilterQueryKeys';

type Vars = {
  id: string;
  payload: UpdateOfferBypassRegionFilterSettingPayload;
};

export function useUpdateOfferBypassRegionFilterSetting() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, payload }: Vars) => updateOfferBypassRegionFilterSetting(id, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: offerBypassRegionFilterQueryKeys.lists() });
    },
  });
}
